import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';
import { HttpService } from './http.service';
import { SnackbarService } from './snackbar.service';
import { Observable, throwError, of } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { tap, catchError } from 'rxjs/operators';
import {AdalService} from 'adal-angular4';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        public auth: HttpService,
        public snackbar: SnackbarService,
        private router: Router,
        private _location: Location,
        public adal: AdalService
    ) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((ev) => {
                if (ev instanceof HttpResponse) {
                    if (ev.status === 204) {
                        // console.log('response in the catch: ', ev.statusText);
                    }
                }
            }),
            catchError((err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403) {
                        this.snackbar.info('Brak uprawnień.');
                    }
                    // if(err.status === 401) this.adal.refreshDataFromCache();
                }
                return throwError(err);
            })
        );
    }
}
